import React, { createContext, useContext, useState } from 'react';

// Create a context for managing the sidebar state
const SidebarContext = createContext();

export const useSidebar = () => useContext(SidebarContext);  // Custom hook to use the sidebar context

export const SidebarProvider = ({ children }) => {
  const [isConfigOpen, setConfigOpen] = useState(false);  // Manage the config open state

  const toggleConfig = () => {
    setConfigOpen(prevState => !prevState);  // Toggle the config bar
  };

  return (
    <SidebarContext.Provider value={{ isConfigOpen, toggleConfig }}>
      {children}  {/* Pass down the state and toggle function */}
    </SidebarContext.Provider>
  );
};
